import type { NextRuntimeConfiguration } from '@libs/config';
import getConfig from 'next/config';
import Script from 'next/script';

export interface GoogleTagManagerProps {
  id: string;
}

export const GoogleTagManager = ({ id }: GoogleTagManagerProps) => {
  if (!id) {
    return null;
  }

  const { publicRuntimeConfig } = getConfig() as NextRuntimeConfiguration;

  const gtmScript = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', '${id}');
  `;

  return (
    <Script
      id="google-tag-manager-script"
      // only use beforeInteractive on environments that are not local for debugging purposes
      strategy={publicRuntimeConfig.envName === 'testing' ? undefined : 'beforeInteractive'}
      data-testid="googletagmanager"
      dangerouslySetInnerHTML={{ __html: gtmScript }}
    />
  );
};
